import React, { useState, useEffect } from "react";

export default function PopUp() {
  const [isVisible, setIsVisible] = useState(false);
  const [popUps, setPopUps] = useState([]);

  useEffect(() => {
    fetch("https://api.spadserver.com/api/popup")
      .then((response) => response.json())
      .then((data) => {
        const activePopUps = data.data.filter((popUp) => popUp.status !== "0");
        console.log("Active Pop-Ups:", activePopUps);
        setPopUps(activePopUps);

        if (activePopUps.length > 0) {
          setIsVisible(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching pop-up data:", error);
      });
  }, []);

  const getPositionClasses = (type) => {
    switch (type) {
      case "up":
        return "top-0";
      case "down":
        return "bottom-0";
      case "center":
        return "top-1/2 transform -translate-y-1/2";
      default:
        return "top-1/2 transform -translate-y-1/2";
    }
  };

  return (
    <>
      {isVisible && popUps.length > 0 && (
        <div
          className={`fixed inset-x-0 ${getPositionClasses(
            popUps[0].type
          )} bg-black bg-opacity-50 flex justify-center items-center p-4 transition-opacity duration-500 ${
            isVisible ? "opacity-100" : "opacity-0"
          }`}
          style={{ zIndex: 1000 }}
        >
          <div
            className="relative bg-[#0C1121] text-white p-6 rounded-xl shadow-lg w-full max-w-lg transition-transform duration-500 transform border-[1px] border-white"
            style={{ transform: isVisible ? "scale(1)" : "scale(0.9)" }}
          >
            {/* Close Button */}
            <button
              className="absolute top-4 left-4 text-white bg-red-600 hover:bg-red-700 rounded-full p-[1px] focus:outline-none"
              onClick={() => setIsVisible(false)}
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>

            <div className="flex flex-col items-center mb-4">
              <div className="w-8 h-8 rounded-full bg-gradient-to-r from-blue-400 to-blue-600 flex items-center justify-center">
                <svg
                  className="w-5 h-5 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 00-9-5.197V5a2 2 0 11-4 0v-.197A6 6 0 006 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m5 0v2a2 2 0 11-4 0v-2m4 0H9"
                  ></path>
                </svg>
              </div>
              <h2 className="text-xl font-semibold mt-2">اطلاعیه</h2>
            </div>

            <div>
              {popUps.map((popUp) => (
                <div key={popUp.id} className="mb-6 flex flex-col items-center">
                  <div
                    className="text-lg mb-2"
                    dangerouslySetInnerHTML={{ __html: popUp.description }}
                  />
                  {popUp.btn_link && (
                    <a
                      href={popUp.slug}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block mt-4 px-4 py-3 text-black text-center popUpButton w-[200px] rounded-[30px]"
                    >
                      {popUp.btn_link}
                    </a>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
